module.exports = __webpack_public_path__ + "static/media/_england.d39f7a13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_england.svg
// module id = 2318
// module chunks = 7